import { Routes, Route } from 'react-router-dom';
import { SearchProvider } from '@/context/SearchContext';
import { FiltersProvider } from '@/context/FiltersContext';
import { StationProvider } from '@/context/StationContext';
import { Map } from '@/components/map/Map';
import { SearchPanel } from '@/components/search/SearchPanel';
import { FilterPanel } from '@/components/filters/FilterPanel';
import { StationDrawer } from '@/components/station/StationDrawer';
import { useSearch } from '@/context/SearchContext';
import { useIsMobile } from '@/hooks/useMediaQuery';

function HomePage() {
  const isMobile = useIsMobile();
  const { isExpanded, hasSearched } = useSearch();

  return (
    <div className="relative overflow-hidden bg-gray-100" style={{ height: '100vh', width: '100vw' }}>
      {/* Map - full screen background */}
      <Map className="absolute inset-0" style={{ height: '100%', width: '100%' }} />

      {/* Search panel - handles its own positioning on mobile, positioned top-left on desktop */}
      <div className={isMobile ? '' : 'absolute top-4 left-4 z-20 w-96'}>
        <SearchPanel />
      </div>

      {/* Filter panel - only shown after search, positioned below search */}
      {hasSearched && !isExpanded && (
        <div
          className={
            isMobile
              ? 'absolute top-20 left-2 right-2 z-10'
              : 'absolute top-20 left-4 w-96 z-10'
          }
        >
          <FilterPanel />
        </div>
      )}

      {/* Station detail drawer */}
      <StationDrawer />
    </div>
  );
}

export default function App() {
  return (
    <SearchProvider>
      <FiltersProvider>
        <StationProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            {/* Future routes */}
            {/* <Route path="/about" element={<AboutPage />} /> */}
            {/* <Route path="/station/:id" element={<StationPage />} /> */}
          </Routes>
        </StationProvider>
      </FiltersProvider>
    </SearchProvider>
  );
}
